<template>
  <div>
    <div class="card-item-scoped" @mouseout="model = false">
      <div class="btn-box" @mouseover="model = true">
        <video
          v-if="/\.(mp4|rmvb|mov|rm|3gp|flv|avi)$/.test(imgUrl)"
          class="card-img-scoped"
          muted="muted"
          x5-video-player-fullscreen="true"
          x5-video-orientation="portraint"
          webkit-playsinline=""
          x5-video-player-type="h5"
          preload=""
          playsinline=""
          :src="imgUrl"
        >
           您的浏览器暂不支持改视频！
        </video>
        <img
          v-else
          class="card-img-scoped"
          :src="mini(imgUrl, { w: 170, limit: 1 })"
        />
      </div>
      <div class="card-footer-scoped">
        <p class="footer-text">{{ fileName }}</p>
        <img
          :data-track="
            JSON.stringify({
              m: '0000', // 模块标识， 非必填
              t: '1000', // 事件点位标识
              options:{
                url:imgUrl
              },
            })
          "
          class="footer-icon"
          src="https://mktv-in-cdn.mockuai.com/16365953880906655.png"
          style="width: 12px; height: 12px;"
          @click="downLoadImg"
        />
      </div>
      <div class="card-model" v-if="model" @mouseover.capture="model = true">
        <slot name="btn"></slot>
      </div>
    </div>
    <div class="author" v-if="author">
      <div>上传者：{{ author.split("(")[0] }}</div>
      <div v-if="uploadTime">
        {{
          new Date(uploadTime * 1).toLocaleDateString("default", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mini } from "@/js/miniImg";
export default {
  props: {
    imgUrl: {
      type: String,
      require: true,
    },
    fileName: {
      type: String,
      default: "",
    },
    author: {
      type: String,
      default: "",
    },
    uploadTime: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      model: false,
    };
  },
  methods: {
    mini,
    downLoadImg() {
      this.$emit("down");
    },
  },
};
</script>

<style scoped>
.author {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  padding: 0 10px;
  color: #999999;
  background: linear-gradient(180deg, #f8f8f8 0%, #ffffff 100%);
  border-radius: 0px 0px 8px 8px;
}
.btn-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: inherit;
  min-height: inherit;
  max-height: inherit;
}
.card-item-scoped {
  position: relative;
  box-sizing: border-box;
  background-color: #f1f0f0;
  width: 190px;
  min-height: 190px;
  padding-top: 10px;
  /* max-height: 304px; */
  border-radius: 8px;
  /* border: 1px solid #e7e7e7; */
  overflow: hidden;
}
/* card-footer 名称被用了，样式全局影响 */
.card-footer-scoped {
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: inherit;
  padding: 10px 12px;
  background-color: #fff;
}
.footer-icon {
  cursor: pointer;
  flex-shrink: 0;
}
.footer-icon::before {
  content: "";
  position: absolute;
  top: -20px;
  right: -20px;
  bottom: -20px;
  left: -20px;
}
.footer-text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333;
}
.card-img-scoped {
  max-width: 190px;
  height: auto;
}
.card-model {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: inherit;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.model-btn {
  text-align: center;
  color: #fff;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  width: 92px;
  height: 28px;
  line-height: 28px;
  border-radius: 4px;
  border: 1px solid #fff;
  cursor: pointer;
}
.model-btn + .model-btn {
  margin-top: 12px;
}
</style>
